import { render } from "./CompanyDetail.vue?vue&type=template&id=45ab3fc4&scoped=true"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"

import "./CompanyDetail.vue?vue&type=style&index=0&id=45ab3fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ab3fc4"]])

export default __exports__